import { memo } from 'react';

import { FilterRowWithCheckbox } from '~/components/Filters/FilterRowWithCheckbox';
import { type BaseStringSelectProps } from '~/components/StringSelect';

const ORIENTATION_OPTIONS = [
  { label: 'Portrait', value: 'portrait' },
  { label: 'Landscape', value: 'landscape' },
  { label: 'Square', value: 'square' },
];

export const OrientationFilter = memo(({ selectedValues, onSelectionChange }: BaseStringSelectProps) => {
  const handleOrientationToggle = (value: string, isSelected: boolean) => {
    if (isSelected) {
      onSelectionChange([...selectedValues, value]);
    } else {
      onSelectionChange(selectedValues.filter((v) => v !== value));
    }
  };

  return (
    <div>
      {ORIENTATION_OPTIONS.map((option) => (
        <FilterRowWithCheckbox
          key={option.value}
          label={option.label}
          isSelected={selectedValues.includes(option.value)}
          onChange={(isSelected) => handleOrientationToggle(option.value, isSelected)}
        />
      ))}
    </div>
  );
});

OrientationFilter.displayName = 'OrientationFilter';
